import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { emptyObject } from 'ui-components/default-props/empty';
import { useEntitiesFulfillment } from '../../../../../../../hooks/entities/selectors/fulfillments';
import useOpenVoidModal from '../../../../../hooks/use-open-void-modal';
import messages from '../../../../../rate-card/read-only/label-actions/messages';

const VoidShipmentMenuItem = ({ fulfillmentId }) => {
  const fulfillment = useEntitiesFulfillment(fulfillmentId) || emptyObject;
  const openVoidModal = useOpenVoidModal({ fulfillment });
  const disabled = !fulfillment || fulfillment.isLabelVoided;

  return (
    <DropdownMenuItem disabled={disabled} onClick={openVoidModal}>
      <FormattedMessage {...messages.voidLabel} />
    </DropdownMenuItem>
  );
};

export { VoidShipmentMenuItem };

VoidShipmentMenuItem.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};
